import React from 'react';

const WhyDidYouDoThat = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#1e1e1e',
        color: '#00ff00',
        fontFamily: 'Consolas, monospace',
        fontSize: '48px',
        textAlign: 'center',
      }}
    >
      <div>:&#40;</div>
      <div>Why did you do that?</div>
    </div>
  );
};

export default WhyDidYouDoThat;